import {Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {Subject} from 'rxjs'
import {Cookie} from 'ng2-cookies';
@Injectable()
export class SessionService{
    private user : any;
    private subject = new Subject <any>();

    setUser(user : any){
        
        this.user = user;
        localStorage.removeItem("currUser");
        if(this.user != undefined){
            if(this.user.images!=undefined && this.user.images.length>0 ){
                for(let i in this.user.images){
                    if(this.user.images[i].size=="med"){
                        this.user.imgUrl = this.user.images[i].url;
                    }
                }
            }
            Cookie.set('apitkn', this.user.api_token, 1);
            localStorage.setItem('currUser', JSON.stringify(this.user));
            Cookie.set('currUser', '1');
        }

        this.subject.next(this.user);
    }
    logout(){
        this.setUser(undefined);
    }
    getUser(): Observable<any>{
        return this.subject.asObservable();
    }
}